import React from 'react'

export const FormatDate = (date) => {
    const timestamp = new Date(date).getTime();
    const day = new Date(timestamp).getDate();
    const Month = new Date(timestamp).toLocaleString("default", {
      month: "long",
    });
    const year = new Date(timestamp).getFullYear();
    const newDate = `${day} ${Month}, ${year}`;
    return newDate;
  
}